import React, { useEffect } from 'react'
import { withRouter, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Loader } from '../../components'
import { formatPrice } from '../../helpers'
import { actionDetailTransactionPublic } from '../../store/actions/transaction'
import { actionAlert } from '../../store/actions/util'
import './TransactionPublicDetail.css'

const getStatusInfo = (status) => {
  const statusNum = Number(status)
  if (status === null || status === undefined || isNaN(statusNum)) {
    return {
      text: 'Menunggu Konfirmasi',
      color: '#64748b'
    }
  }

  switch (statusNum) {
    case 0:
      return {
        text: 'Dalam Proses',
        color: '#d97706'
      }
    case 1:
      return {
        text: 'Selesai',
        color: '#059669'
      }
    case 2:
      return {
        text: 'Ditolak',
        color: '#dc2626'
      }
    default:
      return {
        text: 'Menunggu Konfirmasi',
        color: '#64748b'
      }
  }
}

const TransactionPublicDetail = ({
  transaction,
  contact,
  dispatchDetailTransactionPublic,
  dispatchAlert,
  history,
  match
}) => {
  const code = match?.params?.code

  useEffect(() => {
    if (code) {
      dispatchDetailTransactionPublic(code)
    }
  }, [code, dispatchDetailTransactionPublic])

  useEffect(() => {
    if (transaction?.error) {
      const errorMsg = transaction.error.message || 'Transaksi tidak tersedia atau tidak dapat diakses.'
      if (dispatchAlert) {
        dispatchAlert(true, 'error', errorMsg)
      }

      const targetPath = '/'
      if (history) {
        history.push(targetPath)
      } else {
        window.location.href = targetPath
      }
    }
  }, [transaction?.error, dispatchAlert, history])

  if (transaction?.loading || !transaction?.payload) {
    return (
      <div className="trx-public-wrapper">
        <Loader />
      </div>
    )
  }

  const data = transaction.payload
  const contactPhone = contact?.payload?.phone || ''
  const statusInfo = getStatusInfo(data.status)

  const handleGoToHome = (e) => {
    e.preventDefault()
    const targetPath = data.referral ? `/?referral=${data.referral}` : '/'
    if (history) {
      history.push(targetPath)
    } else {
      window.location.href = targetPath
    }
  }

  const orders = data.orders || []
  const subtotal = orders.reduce((acc, item) => acc + (Number(item.price || 0) * Number(item.quantity || 1)), 0)
  const total = Number(data.total || subtotal)
  const discountAmount = data.voucher ? Number(data.voucher.discount || 0) : (subtotal > total ? subtotal - total : 0)

  let messageText = ''
  for (const item of orders) {
    const prod = item.product || {}
    const itemPrice = item.price || 0
    const qty = item.quantity || 1
    messageText += `- ${prod.name || 'Produk'} @${formatPrice(itemPrice, 'Rp.')} x ${qty}%0A`
  }

  messageText += `%0ATotal Belanja ${formatPrice(subtotal > 0 ? subtotal : total, 'Rp.')}`
  if (discountAmount > 0) {
    messageText += `%0APotongan Harga ${formatPrice(discountAmount, '- Rp.')}`
  }
  messageText += `%0ATotal Bayar ${formatPrice(total, 'Rp.')}`

  const baseUrl = window.location.origin
  const detailUrl = `${baseUrl}/pembelian/${data.code}`
  const text = `Kode ${data.code}%0ALink: ${detailUrl}%0A%0A${messageText}`
  const waBaseUrl = process.env.REACT_APP_WHATSAPP_URL || 'https://api.whatsapp.com/send?phone='
  const whatsappUrl = `${waBaseUrl}${contactPhone}&text=${text}`

  return (
    <div className="trx-public-wrapper">
      <div className="trx-public-card">
        
        {/* Header Status Sukses */}
        <div className="trx-public-header">
          <div className="trx-public-icon-circle">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="trx-public-header-title">Pesanan Berhasil Dibuat!</h1>
          <p className="trx-public-header-sub">
            Nomor Invoice: <span className="trx-public-invoice-code">{data.code}</span>
          </p>
        </div>

        {/* Detail Konten Transaksi */}
        <div className="trx-public-content">

          {/* Detail Produk */}
          <div>
            <h2 className="trx-public-section-title">Ringkasan Produk</h2>
            {orders.map((item, index) => {
              const prod = item.product || {}
              const imageUrl = prod.image
                ? (prod.image.startsWith('http') ? prod.image : (process.env.REACT_APP_IMAGE_URL || '') + prod.image)
                : ''
              return (
                <div key={index} className="trx-public-product-item">
                  {imageUrl ? (
                    <img src={imageUrl} alt={prod.name || 'Produk'} className="trx-public-product-img" />
                  ) : (
                    <div className="trx-public-product-img" />
                  )}
                  <div className="trx-public-product-info">
                    <h3 className="trx-public-product-name">{prod.name || 'Produk Herbal'}</h3>
                    <p className="trx-public-product-qty">Jumlah: {item.quantity || 1} Pcs</p>
                  </div>
                  <div className="trx-public-product-price">
                    {formatPrice(item.price || 0, 'Rp ')}
                  </div>
                </div>
              )
            })}
          </div>

          {/* Rincian Biaya */}
          <div className="trx-public-breakdown">
            <div className="trx-public-row">
              <span>Harga Produk</span>
              <span>{formatPrice(subtotal > 0 ? subtotal : total, 'Rp ')}</span>
            </div>
            {discountAmount > 0 && (
              <div className="trx-public-row trx-public-row-discount">
                <span>Diskon Khusus Mitra (Grade B)</span>
                <span>- {formatPrice(discountAmount, 'Rp ')}</span>
              </div>
            )}
            <div className="trx-public-row">
              <span>Biaya Pengiriman (Reguler)</span>
              <span>Rp 0</span>
            </div>
            <div className="trx-public-row trx-public-row-total">
              <span>Total Pembayaran</span>
              <span className="total-price">{formatPrice(total, 'Rp ')}</span>
            </div>
          </div>

          {/* Info Alamat & Pembayaran */}
          <div className="trx-public-info-grid">
            <div className="trx-public-info-card">
              <p className="trx-public-info-label">Metode Bayar</p>
              <p className="trx-public-info-val">{data.payment_method || 'COD (Bayar di Tempat)'}</p>
            </div>
            <div className="trx-public-info-card">
              <p className="trx-public-info-label">Status Pesanan</p>
              <p
                className="trx-public-info-val"
                style={{ color: statusInfo.color, fontWeight: '700' }}
              >
                {statusInfo.text}
              </p>
            </div>
          </div>

          {/* Instruksi Lanjutan / Aksi WA */}
          <div style={{ paddingTop: '8px' }}>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="trx-public-cta-btn"
            >
              <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', fill: 'currentColor' }} viewBox="0 0 24 24">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
              </svg>
              <span>Konfirmasi Pesanan via WhatsApp</span>
            </a>
          </div>

        </div>

        {/* Footer Info */}
        <div className="trx-public-footer">
          <a
            onClick={handleGoToHome}
            href={data.referral ? `/?referral=${data.referral}` : '/'}
          >
            Lihat Produk-Produk Lainnya? Klik di sini
          </a>
        </div>

      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    transaction: state.transaction.detailTransaction,
    contact: state.util.contact
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchDetailTransactionPublic: (code) => dispatch(actionDetailTransactionPublic(code)),
    dispatchAlert: (status, severity, message) => dispatch(actionAlert(status, severity, message))
  }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TransactionPublicDetail)
